<template>
  <div class="data_tabs">
    <a-tabs type="card" style="background: #ffffff">
      <a-tab-pane key="1" tab="设备信息">
        <asset-worth ref="assetWorth" :model="model"></asset-worth>
      </a-tab-pane>
      <a-tab-pane key="2" tab="业务信息">
      </a-tab-pane>
      <a-tab-pane key="3" tab="备件信息">
      </a-tab-pane>
      <a-tab-pane key="4" tab="文档信息">
      </a-tab-pane>
      <a-tab-pane key="5" tab="子设备信息">
      </a-tab-pane>
      <a-tab-pane key="6" tab="二维码打印记录">
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import AssetWorth from '@/views/gasManagement/modules/assetWorth'
export default {
  props: {
    model: Object
  },
  components: {
    AssetWorth
  },
  data  () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.data_tabs {
  border: 2px solid #f0f2f5;
  /deep/.ant-tabs-bar {
    border: 0;
    margin-bottom: 0;
    .ant-tabs-nav-container {
      padding-left: 8px;
      border-bottom: 1px solid #DDDDDD;
      // border: 0;

      .ant-tabs-tab {
        border: 0;
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
        margin: 7px 0;
        margin-right: 16px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
      }
      .ant-tabs-tab-active {
        color: #1791FF;
        background: rgba(23, 145, 255, 0.1);
      }
    }
  }

  // /deep/.ant-tabs-tab{
  //   border: 0 !important;
  //   height: 26px !important;
  //   line-height: 26px !important;
  //   padding: 0 10px !important;
  //   margin: 7px 0 !important;
  //   margin-right: 16px !important;
  // }
  // /deep/.ant-tabs-tab-active{
  //   background: rgba(23, 145, 255, 0.1) !important;
  // }
}
</style>
